$(document).on('turbolinks:load', function() {
  $('#renewal-modal').modal('show');
});
